import { FirebaseApp, initializeApp } from '@angular/fire/app';
import { connectDatabaseEmulator, Database, getDatabase } from '@angular/fire/database';
import { MapHlp } from 'src/lib/fliko/helpers/map.helper';

import { environment } from '../../../environments/environment';

export class FireDbService {
  public static readonly commonDbName = environment.commonName;

  private static appRef: FirebaseApp;
  private static commonDbRef: Database;

  private static shardDbRefs = new Map<string, Database>();
  private static readonly _shardDbNames = environment.shardNames;

  private static config = environment.firebaseConfig;

  /**
   * Initialize common app
   * ! used only in app.module.ts
   */
  public static initApp(): FirebaseApp {
    FireDbService.appRef = initializeApp(FireDbService.config);
    return FireDbService.appRef;
  }

  /**
   * Initialize common database reference
   * ! used only in app.module.ts
   */
  public static initDatabases(): Database {
    if (!FireDbService.appRef) throw new Error('App not initialized');
    FireDbService.commonDbRef = getDatabase(FireDbService.appRef, FireDbService.prepareURL(FireDbService.commonDbName));
    for (const name of FireDbService._shardDbNames) {
      const shardDb = getDatabase(FireDbService.appRef, FireDbService.prepareURL(name));
      FireDbService.shardDbRefs.set(name, shardDb);
    }
    return FireDbService.commonDbRef;
  }

  /**
   * Initialize database emulator connection
   * ! used only in app.module.ts
   */
  public static initDbEmulator(): void {
    connectDatabaseEmulator(FireDbService.commonDbRef, 'localhost', 9002);
    for (const name of FireDbService._shardDbNames) {
      const shardDb = getDatabase(FireDbService.appRef, FireDbService.prepareURL(name));
      FireDbService.shardDbRefs.set(name, shardDb);
      connectDatabaseEmulator(shardDb, 'localhost', 9002);
    }
  }

  /**
   * Get database reference by name (if not exist, create)
   * @param {string} name database name
   * @return {Database} database reference
   * @throws {Error} When database name is not on list of available databases (+ common)
   */
  public static getDbRef(name: string): Database {
    if (name == FireDbService.commonDbName) {
      return FireDbService.commonDbRef;
    } else if (FireDbService._shardDbNames.includes(name)) {
      return MapHlp.getSet(FireDbService.shardDbRefs, name, () => getDatabase(FireDbService.appRef, name));
    } else {
      throw new Error('Invalid database');
    }
  }

  private static prepareURL(name: string): string {
    return environment.databaseUrlBase.replace('%NAME%', name);
  }
}
